import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function FilterField({
  label,
  children,
  className,
}: {
  label: string;
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div className={cn('grid w-full gap-1 md:w-auto', className)}>
      <span className="text-xs uppercase tracking-wide text-muted-foreground">{label}</span>
      {children}
    </div>
  );
}
